export default {
  width: 10,
  height: 7,
  fill: false,
  stroke: true,
  svg: `
<path d="M2 2L5 5L8 2" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square" />
`
}
